import { ApolloLink } from 'apollo-link';
import { HttpLink } from 'apollo-link-http';
import { getMainDefinition } from 'apollo-utilities';

import { UFOLoggerLink } from '@atlassian/ufo-apollo-log/link';

import { websocketLink } from './websocket-link';

export function createLinks(
  headers: Record<string, string>,
  hasWebsocketSubscriptions: boolean
): ApolloLink {
  const httpLink = new HttpLink({
    credentials: 'include',
    uri: '/gateway/api/graphql',
    headers,
  });

  if (hasWebsocketSubscriptions) {
    return ApolloLink.from([
      UFOLoggerLink,
      // Split communication protocol by operation:
      // - Websocket for subscriptions
      // - HTTP for queries and mutations
      ApolloLink.split(
        ({ query }) => {
          const definition = getMainDefinition(query);
          return (
            definition?.kind === 'OperationDefinition' &&
            definition?.operation === 'subscription'
          );
        },
        websocketLink,
        httpLink
      ),
    ]);
  }

  return ApolloLink.from([UFOLoggerLink, httpLink]);
}
